export default __webpack_public_path__ + "static/media/unselected13.f860ba0f.png";